"use client";

import * as React from "react";
import { H3 } from "./heading-with-anchor";

export function HeadingWithAnchorAlignmentDemo() {
  return (
    <div className="space-y-8">
      <div className="space-y-2">
        <p className="text-sm font-medium text-muted-foreground">
          Spaced Alignment (default)
        </p>
        <H3 anchor="alignment-spaced" anchorAlignment="spaced">
          Heading with Spaced Anchor
        </H3>
        <p className="text-sm text-muted-foreground">
          The anchor is placed away from the text
        </p>
      </div>

      <div className="space-y-2">
        <p className="text-sm font-medium text-muted-foreground">
          Close Alignment
        </p>
        <H3 anchor="alignment-close" anchorAlignment="close">
          Heading with Close Anchor
        </H3>
        <p className="text-sm text-muted-foreground">
          The anchor is placed immediately after the text
        </p>
      </div>
    </div>
  );
}
